import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDrag, useDrop, DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { AlignmentConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/AlignmentConfig';
import { BoldConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/BoldConfig';
import { ColorConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/ColorConfig';

export function CustomSetting({ obj, updateSetting, handleChangeByPath }) {
  const { t } = useTranslation('common');

  const onChange = (value, key) => {
    const objClone = { ...obj };
    objClone[key] = value;
    updateSetting(objClone);
  };

  const updateCustomSectionControlsSequence = (controls) => {
    const objClone = { ...obj };
    objClone.controls = controls;
    updateSetting(objClone);
  };

  return (
    <div className="common-input-control">
      <p className="field-name">{t('DPP.CONTROL.CUSTOM_SECTION.TITLE')}</p>
      <input
        type="text"
        className="form-control"
        value={obj?.title}
        placeholder={t('DPP.CONTROL.GOOGLE.ENTER_TITLE')}
        onChange={(e) => onChange(e.target.value, 'title')}
        maxLength="40"
      />
      <div className="d-flex">
        <AlignmentConfig obj={obj} handleAlignment={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.alignment')} dataName="alignment" />
        <ColorConfig obj={obj} handleColor={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.colour')} dataName="colour" />
        <BoldConfig obj={obj} handleBold={(e) => handleChangeByPath(e.target.checked, 'otherConfiguration.bold')} dataName="bold" />
      </div>
      <div className="common-input-control mb-0">
        <p className="f-16 text-bold field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.SUB_HEADER_TITLE')}</p>
        <input
          type="text"
          className="form-control"
          value={obj?.subHeaderTitle}
          placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.ENTER_SUBHEADER_TITLE')}
          onChange={(e) => onChange(e.target.value, 'subHeaderTitle')}
          maxLength="40"
        />
      </div>

      <div className="d-flex">
        <AlignmentConfig obj={obj} handleAlignment={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.subHeaderAlign')} dataName="subHeaderAlign" />
        <ColorConfig obj={obj} handleColor={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.subHeaderColor')} dataName="subHeaderColor" />
        <BoldConfig obj={obj} handleBold={(e) => handleChangeByPath(e.target.checked, 'otherConfiguration.subHeaderBold')} dataName="subHeaderBold" />
      </div>
      {obj?.controls?.length > 0 && <p className="text-medium mb-16">{t('DPP.CONTROL.CUSTOM_SECTION.REARRANGE_SEQUENCE')}</p>}
      <DndProvider backend={HTML5Backend}>
        <DraggableList items={obj?.controls || []} updateCustomSectionControlsSequence={updateCustomSectionControlsSequence} />
      </DndProvider>
    </div>
  );
}

export default CustomSetting;

function DraggableList({ items, updateCustomSectionControlsSequence }) {
  const moveItem = (dragIndex, hoverIndex) => {
    const updatedItems = [...items];
    const [draggedItem] = updatedItems.splice(dragIndex, 1);
    updatedItems.splice(hoverIndex, 0, draggedItem);
    updateCustomSectionControlsSequence(updatedItems);
  };

  return (
    <div>
      {items?.map((item, index) => (
        <DraggableItem key={index} index={index} id={index} text={item.label} moveItem={moveItem} />
      ))}
    </div>
  );
}

const ItemType = 'DRAGGABLE_ITEM';

function DraggableItem({ id, text, index, moveItem }) {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: ItemType,
    hover(item) {
      if (item.index === index) return;
      moveItem(item.index, index);
      item.index = index;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: { id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <div className="custom-item-card drag-drop-item" ref={ref}>
      <div className="move-cursor">
        <i className="icon-Rearrange f-20" />
      </div>
      <div className="ml-16">
        <label className="m-0">
          <span className="text-bold">{text}</span>
        </label>
      </div>
    </div>
  );
}
